export default (lowestLiabilityMet: LiabilityMet, userLiability: number): boolean =>
    lowestLiabilityMet === 'n/a' || lowestLiabilityMet >= userLiability;

export type LiabilityMet = number | 'n/a';



// WEBPACK FOOTER //
// ./src/domain/isLiabilityMet.ts